import { UserActionsEnum } from 'Common/Enums/mxnotifications.enums';
import ContactBody from 'Common/Models/contact-body.model';
import { ContactBoxMode } from 'Common/Models/selected-contact.model';

export class BroadcastHelper {
    static BroadcastMessageToOtherTabs(data: BroadcastData) {
        if (window && data) {
            const win = window as any;
            if (
                win.MXNotificationClient &&
                win.MXNotificationClient.BroadcastToTabs
            ) {
                win.MXNotificationClient.BroadcastToTabs(data);
            }
        }
    }
}
export enum BroadCastType {
    UserActivity = 3,
    AppActivity = 4,
}
export interface BroadcastData {
    message: string;
    type: BroadCastType;
}

export interface ContactBroadCastData {
    ActionData?: ContactBody;
    ActionType: UserActionsEnum;
    RecenctContactMode?: ContactBoxMode;
    SessionId?: string;
    TotalUnreadCount?: number;
}
